import { Link } from 'react-router-dom';
import { BASE_URL } from '@/config';

export default function NotFound() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-gray-100">
      <h1 className="text-4xl font-bold text-gray-800">404</h1>
      <p className="mt-2 text-gray-600">Page non trouvée</p>
      <Link
        to={BASE_URL}
        className="mt-4 rounded-md bg-primary-600 px-4 py-2 text-white hover:bg-primary-700"
      >
        Retour à l&apos;accueil
      </Link>
    </div>
  );
}
